const isLocal = process.env.REACT_APP_FUNC_URL!.includes("localhost");

export const baseUrl = isLocal
  ? process.env.REACT_APP_FUNC_URL
  : `https://${process.env.REACT_APP_FUNC_URL}.azurewebsites.net/api`;
export const code = isLocal ? "" : process.env.REACT_APP_FUNC_KEY;

export const acheteur = "sections/acheteur";
export const activites = "/activite";
export const bannieres = "/banniere";
export const caracteristiques = "/planogramme/caracteristiques";
export const collection = "/collection";
export const dashboard = "/dashboard";
export const divisions = "/divisions";
export const ensemble = "/planogramme/ensemble";
export const error = "/error";
export const fournisseur = "/fournisseur";
export const login = "/auth/login";
export const magasin = "/sections/magasin";
export const magasins = "/magasins";
export const modele = "/modele";
export const planogramme = "/planogramme";
export const planogramme_produit = "/planogramme/produits";
export const planogrammes = "/planogrammes";
export const produit = "/planogramme/produit";
export const produit_section = "/planogramme/produit/section";
export const secCombo = "/sections/combo";
export const secMagasin = "/section/magasin";
export const sections = "/sections";
export const selection = "/sections/selection";
export const stats = "/planogramme/stats";
export const statut = "/statut";
export const tableauDeBord = "/tableau-de-bord";
export const userPreferences = "/userPreferences";
export const users = "/usager";
export const vise = "/planogramme/vise";
export const statistiques = "/statistiques";